import React from "react";
import DatePicker from "../../../../../common/datepicker/DatePicker";
import InputBox from "../../../../../common/input/InputBox";
import TextAreaBox from "../../../../../common/input/TextAreaBox";
import TextAreaWithSpeech from "../../../../../common/input/TextAreaWithSpeech";

const PaymentInfo = ({ formik, details, discount = true, edit }) => {
  // Running totals for the read-only footer. Items = medicines actually
  // picked on this bill; Quantity = sum of per-row quantities.
  const lineItems = formik?.values?.treatment_done_info || [];
  const totalNoItems = lineItems.filter((m) => m?.name).length;
  const totalQuantity = lineItems.reduce(
    (sum, m) => sum + (Number(m?.quantity) || 0),
    0
  );
  // Sum the four tender splits → amountPaid. Balance is computed by the
  // parent via its own effect; the earlier return shape advertised a
  // `balance` callers destructured but never used.
  const sumAmountPaid = (cash, card, upi, bank, existingAmountPaid = 0) =>
    cash + card + upi + bank + existingAmountPaid;

  const handlePaymentChange = (paymentType, e) => {
    // Get current values from formik
    const cashValue = formik.values.paymentIn.cash || 0;
    const cardValue = formik.values.paymentIn.card || 0;
    const upiValue = formik.values.paymentIn.upi || 0;
    const bankTransferValue = formik.values.paymentIn.bankTransfer || 0;
    const existingAmountPaid = details?.oldTotalPayment || 0;

    // Store the updated value in a temporary variable
    const updatedValue = parseFloat(e.target.value) || null;

    // Update the specific payment type value
    formik.setFieldValue(
      `paymentIn.${paymentType}`,
      parseFloat(e.target.value),
    );

    const amountPaid = sumAmountPaid(
      paymentType === "cash" ? updatedValue : cashValue,
      paymentType === "card" ? updatedValue : cardValue,
      paymentType === "upi" ? updatedValue : upiValue,
      paymentType === "bankTransfer" ? updatedValue : bankTransferValue,
      existingAmountPaid
    );

    formik.setFieldValue("paymentIn.amountPaid", amountPaid);
  };

  const handleDiscountChange = (event) => {
    const discount = parseFloat(event.target.value) || null; // Parse the discount as a float, default to 0 if not a valid number
    const totalAmount = formik.values.total_amount;
    const appliedDiscount = discount || 0;
    const discountedTotal = totalAmount - appliedDiscount;
    const amountPaid = formik.values.paymentIn.amountPaid;

    // Calculate amountPaid and balance based on the discount and existing balance
    const balance = discountedTotal - amountPaid;

    // Update Formik values
    formik.setFieldValue("discount", discount);
  };

  // ...

  return (
    <div className="shadow-card rounded-15">
      <div
        className={`shadow-card rounded-tl-15 rounded-tr-15 bg-secondary p-2 pl-4 text-bodyBB text-darkgrey mb-2 flex flex-wrap gap-2 items-center justify-between`}
      >
        <div>Payment Info</div>
        <div className="w-full sm:w-auto">
          <DatePicker
            className={"!h-[40px] w-full sm:!w-[260px] text-bodyRB"}
            startDate={formik.values?.paymentIn?.date}
            onDateChange={(e) => {
              formik.setFieldValue("paymentIn.date", e);
            }}
            error={
              formik.touched?.paymentIn?.date && formik.errors?.paymentIn?.date
            }
            disabled={!edit}
          />
        </div>
      </div>
      {/* Mobile-tight layout: both halves stack vertically, each renders
          its payment fields two-per-row on every breakpoint. */}
      <div className="flex flex-col lg:flex-row lg:justify-around p-3 sm:p-5 gap-3">
        <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:mr-3 flex-1">
          <div>
            <p className="text-bodySB text-darkgrey pb-1">Cash</p>
            <InputBox
              type={"number"}
              name={`paymentIn.cash`}
              value={formik.values.paymentIn.cash ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("cash", e);
              }}
              error={
                formik.touched.paymentIn?.cash && formik.errors.paymentIn?.cash
              }
              disabled={!edit}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1">Card</p>
            <InputBox
              type={"number"}
              name={`paymentIn.card`}
              value={formik.values.paymentIn.card ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("card", e);
              }}
              error={
                formik.touched.paymentIn?.card && formik.errors.paymentIn?.card
              }
              disabled={!edit}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1">UPI</p>
            <InputBox
              type={"number"}
              name={`paymentIn.upi`}
              value={formik.values.paymentIn.upi ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("upi", e);
              }}
              error={
                formik.touched.paymentIn?.upi && formik.errors.paymentIn?.upi
              }
              disabled={!edit}
            />
          </div>
          <div className="">
            <p className="text-bodySB text-darkgrey pb-1">Bank Transfer</p>
            <InputBox
              type={"number"}
              name={`paymentIn.bankTransfer`}
              value={formik.values.paymentIn.bankTransfer ?? 0}
              onChange={(e) => {
                formik.handleChange(e);
                handlePaymentChange("bankTransfer", e);
              }}
              error={
                formik.touched.paymentIn?.bankTransfer &&
                formik.errors.paymentIn?.bankTransfer
              }
              disabled={!edit}
            />
          </div>
          <div className="col-span-2">
            <p className="text-bodySB text-darkgrey pb-1">Notes</p>
            {/* <TextAreaBox
              className={""}
              name={`paymentIn.notes`}
              value={formik.values.paymentIn.notes}
              onChange={formik.handleChange}
              error={
                formik.touched.paymentIn?.notes &&
                formik.errors.paymentIn?.notes
              }
              disabled={!edit}
            /> */}
            <TextAreaWithSpeech
              className={""}
              name={`paymentIn.notes`}
              value={formik.values.paymentIn.notes}
              onChange={formik.handleChange}
              error={
                formik.touched.paymentIn?.notes &&
                formik.errors.paymentIn?.notes
              }
              disabled={!edit}
            />
          </div>
        </div>

        <div className="border-r-2 border-[#B9B9B9] hidden lg:block w-5"></div>
        <div className="border-b-2 border-[#B9B9B9] block lg:hidden mt-1"></div>
        {/*  */}
        <div className="grid grid-cols-2 gap-2 sm:gap-3 h-fit lg:ml-3 flex-1">
          {discount && (
            <div>
              <p className="text-bodySB text-darkgrey pb-1">Discount</p>
              <InputBox
                type={"number"}
                name={`discount`}
                value={formik.values.discount ?? 0}
                onChange={handleDiscountChange}
                error={formik.touched.discount && formik.errors.discount}
                disabled={!edit}
              />
            </div>
          )}
          <div>
            <p className="text-bodyBB mt-1 text-darkgrey pb-1">Total Amount</p>
            <InputBox
              type={"number"}
              name={`total_amount`}
              className={"!h-[42px]"}
              value={formik.values.total_amount ?? 0}
              onChange={formik.handleChange}
              error={formik.touched.total_amount && formik.errors.total_amount}
              disabled={!edit}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1">Amount Paid</p>
            <InputBox
              className={"!bg-[#6AB483] !bg-opacity-[20%] font-semibold"}
              type={"number"}
              name={`paymentIn.amountPaid`}
              value={formik.values.paymentIn.amountPaid ?? 0}
              onChange={formik.handleChange}
              error={
                formik.touched.paymentIn?.amountPaid &&
                formik.errors.paymentIn?.amountPaid
              }
              readOnly={true}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1 ">Balance Amount</p>
            <InputBox
              className={"bg-[#E45353] bg-opacity-[20%] font-semibold"}
              type={"number"}
              name={`balance`}
              value={formik.values.balance ?? 0}
              onChange={formik.handleChange}
              error={formik.touched.balance && formik.errors.balance}
              // disabled={true}
              readOnly={true}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1 ">Total No Item</p>
            <InputBox
              className={" bg-opacity-[20%] font-semibold"}
              type={"number"}
              name={`total_no_items`}
              value={totalNoItems}
              disabled={!edit}
              readOnly={true}
            />
          </div>
          <div>
            <p className="text-bodySB text-darkgrey pb-1 ">Total Quantity</p>
            <InputBox
              className={" bg-opacity-[20%] font-semibold"}
              type={"number"}
              name={`total_quantity`}
              value={totalQuantity}
              disabled={!edit}
              readOnly={true}
            />
          </div>

          <div></div>
        </div>
      </div>
    </div>
  );
};

export default PaymentInfo;
